import { render, staticRenderFns } from "./ProjectInformation.vue?vue&type=template&id=1bc27466&scoped=true"
import script from "./ProjectInformation.vue?vue&type=script&lang=js"
export * from "./ProjectInformation.vue?vue&type=script&lang=js"
import style0 from "./ProjectInformation.vue?vue&type=style&index=0&id=1bc27466&prod&lang=less"
import style1 from "./ProjectInformation.vue?vue&type=style&index=1&id=1bc27466&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc27466",
  null
  
)

export default component.exports